import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { Spinner } from '../../components/spinner';
import { AuthRequired } from '../../components/authentication';
import { ErrorBoundaryFallback } from '../../components/error-boundary-fallback';
import { ROLES } from '../../utils/auth-roles';

export const TiloFacilitatorLayout = () => {
  document.title = 'Catalyst Portal - TILO Facilitator';

  return (
    <AuthRequired allowedRoles={[ROLES.FACILITATOR_PORTAL]}>
      <ErrorBoundary
        fallbackRender={(props) => (
          <ErrorBoundaryFallback isFacilitator {...props} />
        )}>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    </AuthRequired>
  );
};

export default TiloFacilitatorLayout;
